import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class DrawerHeaderPage extends BaseComponent {
  block: Nullable<HTMLElement>

  constructor() {
    super()

    this.block = this.querySelector('[data-drawer-menu-content]')
  }

  connectedCallback(): void {
    if (this.block) {
      this.block.addEventListener('scroll', this.handleBlockScroll)
    }
  }

  disconnectedCallback(): void {
    if (this.block) {
      this.block.removeEventListener('scroll', this.handleBlockScroll)
    }
  }

  handleBlockScroll = (): void => {
    if (!this.block) {
      return
    }

    const isScrolled = this.block.scrollTop > 0

    this.toggleAttribute('header-shadow-visible', isScrolled)
  }
}

export default DrawerHeaderPage
